/**
 * Plain-language part names built from the SKU code (series, size, finish, fabric, vent).
 * Codes come from the Demand mockup's names; anything unknown shows the raw code only.
 * Generated from prototype/names.js. Replace with a Knowledge Hub lookup later.
 * The series / size / finish / fabric lists live in @march/shared (sku_attributes.ts)
 * so Trends and the API group parts with the same names.
 */
import { FABRIC, FINISH, SERIES, SIZE } from "@march/shared";
const FRAME_LABEL: Record<string, string> = {"ALTO":"Venture frame","GSCUF":"Sun Master frame","SDAU":"Sunset frame","GSPT":"Pacific Trail frame"};
const VENT: Record<string, string> = {"SWV":"Single wind vent","DWV":"Double wind vent"};
const EXACT: Record<string, string> = {"5425":"Sunbrella fabric Cocoa","5432":"Sunbrella fabric Bay Brown","RL50":"Base · Heavy-Duty Fillable Base (4-piece)","CRL100-BLACK":"Base · Commercial Rolling Base (100 lb)","CRL100":"Base · Commercial Rolling Base (100 lb)","MARE908":"Grove frame · 9 ft round · Hardwood (no finish code)","TSB4-201":"Base · Stand"};

/** "ALTO908-117" → "Venture frame · 9 ft round · Bronze"; "" when nothing is known. */
export function partName(sku: string): string {
  if (EXACT[sku]) return EXACT[sku];
  let m = sku.match(/^([A-Z]+)(\d{3,4})[A-Z]*-(\d{3})$/);
  if (m) {
    const label = FRAME_LABEL[m[1]] ?? (SERIES[m[1]] ? `${SERIES[m[1]]} frame` : "");
    if (!label) return "";
    return [label, SIZE[m[2]], FINISH[m[3]]].filter(Boolean).join(" · ");
  }
  m = sku.match(/^C(\d{3})-([A-Z]+\d+)(?:-([A-Z]+))?$/);
  if (m) {
    const parts = [SIZE[m[1]] ? `${SIZE[m[1]]} cover` : "Cover", FABRIC[m[2]], m[3] ? VENT[m[3]] : undefined];
    return parts.filter(Boolean).join(" · ");
  }
  if (/^PC\d+$/.test(sku)) return "Protective cover";
  return "";
}

/** "ALTO" → "ALTO · Venture"; unknown series show the code only. */
export const seriesLabel = (code: string) => (SERIES[code] ? `${code} · ${SERIES[code]}` : code);

/**
 * The two things a product line's parts differ by: size, and finish (frames) or fabric (covers).
 * Unknown codes come back as the raw code so nothing is invented.
 */
export function skuFacets(sku: string): { size: string; finish: string } | null {
  let m = sku.match(/^([A-Z]+)(\d{3,4})[A-Z]*-(\d{3})$/);
  if (m) return { size: SIZE[m[2]] ?? m[2], finish: FINISH[m[3]] ?? m[3] };
  m = sku.match(/^C(\d{3,4})-([A-Z]+\d+)(?:-[A-Z]+)?$/);
  if (m) return { size: SIZE[m[1]] ?? `C${m[1]}`, finish: FABRIC[m[2]] ?? m[2] };
  return null;
}
